export function generateIcons(locStrings, m365StringLogoEnabled, isSecondRun) {
    var _a = locStrings.firstRunGeneralResources, m365IconAlt = _a.m365IconAlt, brandIconAlt = _a.brandIconAlt, officeIconAlt = _a.officeIconAlt;
    // TODO: Remove once m365StringLogoEnabled is 100% rolled out.
    var m365HeaderIcon = {
        light: 'm365-logo_light',
        dark: 'm365-logo_dark',
        highContrast: 'm365-logo_light',
        altText: m365IconAlt,
        enabled: !m365StringLogoEnabled,
    };
    if (isSecondRun) {
        m365StringLogoEnabled = true;
    }
    var brandIconName = m365StringLogoEnabled
        ? 'm365-logo_light_and_dark'
        : 'office-icon_light_and_dark';
    var brandIconAltText = m365StringLogoEnabled
        ? brandIconAlt
        : officeIconAlt;
    var brandIcon = {
        light: brandIconName,
        dark: brandIconName,
        highContrast: brandIconName,
        altText: brandIconAltText,
        format: 'svg',
    };
    return {
        m365Icon: m365HeaderIcon,
        brandIcon: brandIcon,
    };
}
//# sourceMappingURL=generateIcons.js.map